import ContactForm2 from "../components/ContactForm2";
import Footer from '../components/Footer';

export default function Careers() {
  return (
    <>
    <section className="min-h-screen py-20 px-6 sm:px-8 bg-[#1A1631] text-white">
      <div className="max-w-5xl mx-auto">
        <a
          href="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          <span className="mr-2 text-lg">←</span> Back to main site
        </a>

        <h1 className="text-4xl md:text-5xl font-bold mb-8">
          <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Careers
          </span>
        </h1>

        <p className="text-lg text-slate-300 mb-12 max-w-2xl">
          We're always excited to hear from talented individuals.
          If you have a background in computational chemistry, AI/ML, or scientific software development,
          feel free to reach out below and tell us about yourself.
        </p>

        <ContactForm2 />
      </div>
    </section>

      {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}

